export const getUrl = () => {
  return typeof window !== "undefined" ? new URL(window.location.href) : null
}

export const getQueryParam = name => {
  const url = getUrl()
  return url ? url.searchParams.get(name) : ""
}
